import Vue from 'vue'
import Router from 'vue-router'
import staticRouter from './modules/static'
import videoRouter from './modules/video'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/HelloWorld')
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: () => import('@/components/HelloWorld')
    },
    {
      path: '/Protocol',
      name: 'Protocol',
      component: () => import('@/components/Protocol')
    },
    {
      path: '/SportModeAlarm',
      name: 'SportModeAlarm',
      component: () => import('@/components/SportModeAlarm')
    },
    {
      path: '/Specification',
      name: 'Specification',
      component: () => import('@/components/Specification')
    },
    {
      path: '/InstructionBook',
      name: 'InstructionBook',
      component: () => import('@/views/instructionBook'),
      meta: { title: 'BabyAlpha 系列产品说明书' }
    },
    {
      path: '/InstructionForeign',
      name: 'InstructionForeign',
      component: () => import('@/views/instructionForeign/instructionBook'),
      meta: { title: 'User Manual for BabyAlpha Series' }
    },
    {
      path: '/EnPartner',
      name: 'EnPartner',
      component: () => import('@/views/enPartner/index'),
      meta: { title: '教程指南' }
    },
    {
      path: '/PrivacyFacial',
      name: 'PrivacyFacial',
      component: () => import('@/views/privacyFacial/index'),
      meta: { title: '人脸离线采集SDK隐私政策' }
    },
    {
      path: '/QQMusicUser',
      name: 'QQMusicUser',
      component: () => import('@/views/protocol/QQMusicUser'),
      meta: { title: 'QQ音乐用户协议' }
    },
    {
      path: '/QQMusicBind',
      name: 'QQMusicBind',
      component: () => import('@/views/protocol/QQMusicBind'),
      meta: { title: 'QQ音乐绑定协议' }
    },
    {
      path: '/QQMusicAccount',
      name: 'QQMusicAccount',
      component: () => import('@/views/protocol/QQMusicAccount'),
      meta: { title: 'QQ音乐账号绑定须知' }
    },
    {
      path: '/paidService',
      name: 'paidService',
      component: () => import('@/views/protocol/paidService'),
      meta: { title: '蔚蓝付费服务协议' }
    },
    ...staticRouter,
    ...videoRouter
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js